import { logout } from '../auth'

export type Page = 'dashboard' | 'worlds' | 'players' | 'packs' | 'update'

interface Props {
  page:       Page
  onNavigate: (p: Page) => void
}

export default function NavBar({ page, onNavigate }: Props) {
  return (
    <nav className="navbar">
      <span className="navbar-brand">⛏ Minecraft <span>Portal</span></span>

      <button className={`nav-tab ${page === 'dashboard' ? 'active' : ''}`}
              onClick={() => onNavigate('dashboard')}>
        Dashboard
      </button>
      <button className={`nav-tab ${page === 'worlds' ? 'active' : ''}`}
              onClick={() => onNavigate('worlds')}>
        Worlds
      </button>
      <button className={`nav-tab ${page === 'players' ? 'active' : ''}`}
              onClick={() => onNavigate('players')}>
        Players
      </button>
      <button className={`nav-tab ${page === 'packs' ? 'active' : ''}`}
              onClick={() => onNavigate('packs')}>
        Packs
      </button>
      <button className={`nav-tab ${page === 'update' ? 'active' : ''}`}
              onClick={() => onNavigate('update')}>
        Update
      </button>

      <span className="nav-spacer" />

      <button className="nav-logout" onClick={logout}>Sign out</button>
    </nav>
  )
}
